import Layout from 'components/layout'
import Theme from 'components/template/Theme'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import useAuth from 'utils/hooks/useAuth'
import history from './history'
import './locales'
import mockServer from './mock'
import store, { persistor } from './store'

const environment = process.env.NODE_ENV

if (process.env.REACT_APP_ENABLE_MOCK === 'true') {
  mockServer({ environment: 'development' })
}

const AuthBootstrap = () => {
  const { bootstrapAuth } = useAuth()

  useEffect(() => {
    bootstrapAuth()
  }, [])

  return null
}

function App() {
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter history={history}>
          			<AuthBootstrap />
					<Theme>
						<Layout />
					</Theme>
				</BrowserRouter >
			</PersistGate>
		</Provider>
	)
}

export default App
